module.exports = __webpack_public_path__ + "img/recipe-add-orange.6f7fbb77.svg";